import { useRouter, useRoute } from 'vue-router'
import { ref } from 'vue'
import { MENU_ITEMS, SUB_LEVELS_ROUTES } from '@/constants/navigationItems'
import { trackEvent } from '@/services/analytics-service'

export const useNavigation = () => {
  const router = useRouter()
  const route = useRoute()

  const findMenuItemBy =
    (prop) =>
    (value, list = MENU_ITEMS) =>
      list.find((el) => el[prop] === value) || {}
  const findMenuItemByName = findMenuItemBy('name')

  const getRouteConfigByPath = () => SUB_LEVELS_ROUTES[route.name as string] || [route.name] || []

  const selectedItemId = ref(getRouteConfigByPath())

  const changeRoute = (name: string) => {
    router.push({ name })
  }

  const updateRoute = (item: MenuItemType) => {
    changeRoute(item.name)
  }

  const setCurrentPath = (idList = [], list = MENU_ITEMS) => {
    const [firstId, ...tail] = idList
    const item = findMenuItemByName(firstId, list) as MenuConfigType

    if (item.subItems && tail.length) {
      setCurrentPath(tail, item.subItems)
    } else if (item.name) {
      item.tracking && trackEvent('GTM_MENU_ITEM', item.tracking)
      updateRoute(item)
    }
  }

  const updateSelectedItem = (idList = []) => {
    selectedItemId.value = idList
    setCurrentPath(idList)
  }

  return {
    selectedItemId,
    updateSelectedItem,
    changeRoute,
    setCurrentPath,
    findMenuItemByName,
    getRouteConfigByPath
  }
}
